import PNLogo from '@propertypal/shared/src/resources/logos/property-news-logo.svg?url';
import Chevron from '@propertypal/web-ui/src/icons/Chevron';
import PageWrapper from '@propertypal/web-ui/src/layout/PageWrapper';
import { MidHeading, Text } from '@propertypal/web-ui/src/typography';
import Link from 'next/link';
import React from 'react';
import { useTheme } from 'styled-components';
import { Anchor, Container, LinksContainer } from './copyright-and-policy-links/CopyrightAndPolicyLinks.style';
import { CopyrightWrapper, FooterContainer, Logo } from './FaqFooter.style.pn';
import { FooterInner, FaqFooterLinks, LinksColumn } from './Footer.style';
import SocialLinks from './social-links/SocialLinks';

const FaqFooter: React.FunctionComponent = () => {
  const theme = useTheme();
  return (
    <FooterContainer className="hide-print">
      <PageWrapper>
        <FooterInner data-testid="faq-footer">
          <FaqFooterLinks>
            <LinksColumn>
              <Link href="/" prefetch={false}>
                <Text as="span" fontSize={11} mb={10} display="block">
                  <Chevron direction="left" size={8} /> Back to
                </Text>
                <ul>
                  <Logo src={PNLogo.src} alt="Propertynews Logo" />
                </ul>
              </Link>
            </LinksColumn>
          </FaqFooterLinks>
          <div>
            <MidHeading fontSize={17} mb={10}>
              FIND US ON SOCIAL
            </MidHeading>
            <SocialLinks />
          </div>
        </FooterInner>
      </PageWrapper>

      <CopyrightWrapper>
        <Container data-testid="footer-copyright">
          <Text fontSize={14} color={theme.textDark}>
            &copy; Copyright Propertynews.com {new Date().getFullYear()}
          </Text>

          <LinksContainer>
            <Anchor href="/privacy" prefetch={false}>
              <Text fontSize={14} color={theme.textDark}>
                Privacy Policy
              </Text>
            </Anchor>

            <Anchor href="/cookie-policy" prefetch={false}>
              <Text fontSize={14} color={theme.textDark}>
                Cookie Policy
              </Text>
            </Anchor>

            <Anchor href="/terms" prefetch={false}>
              <Text fontSize={14} color={theme.textDark}>
                Terms &amp; Conditions
              </Text>
            </Anchor>
          </LinksContainer>
        </Container>
      </CopyrightWrapper>
    </FooterContainer>
  );
};

export default FaqFooter;
